import styles from "../../styles/Components/alert-system/AlertSystem.module.css";
import RiskAppetiteBox from "./alert-config/RiskAppetiteBox";
import AlertFrequencyBox from "./alert-config/AlertFrequencyBox";
import AlertTimeBox from "./alert-config/AlertTimeBox";
import useServiceStatus from "../../hooks/useServiceStatus";
import { FaBell } from "react-icons/fa";
import { useState } from "react";
import ServiceActivationModal from "../../shared/service-activation/ServiceActivationModal";
import TelegramNotificationBox from "./alert-config/TelegramNotificationBox";
import { useDispatch, useSelector } from "react-redux";
import { FaPowerOff } from "react-icons/fa6";
import { Modal, Switch, Tooltip } from "antd";
import { deactivateAutomaticAlert } from "../../redux/alert-system/actions";
import useChangeAlertSystemSettings from "../../hooks/api/alert-system/useChangeAlertSystemSettings";

const AlertSystem2 = () => {
  const {
    alertSystem: { alertStatus, activeAlertLoading },
    main: { userData },
  } = useSelector((state) => state);
  const [showServiceActivation, setShowServiceActivation] = useState(false);

  const { isActive: isAlertActive } = useServiceStatus("alert");

  const dispatch = useDispatch();
  const activateAlertSystem = useChangeAlertSystemSettings();

  const isAlertEnabled = alertStatus?.STATUS === "True";

  const confirmDisableAlert = () => {
    Modal.confirm({
      title: "Disable Smart Alerts?",
      content:
        "You’ll stop receiving smart alerts that help you act at the right time. Are you sure?",
      centered: true,
      okText: "Yes, Disable",
      okType: "danger",
      cancelText: "Keep It On",
      onOk() {
        dispatch(
          deactivateAutomaticAlert(
            userData?.["cognito:username"],
            userData?.["custom:custom_username"],
          ),
        ).then(() => Modal.destroyAll());
      },
    });
  };

  return (
    <div className={styles.container}>
      {/*{isAlertActive && (*/}
      {/*  <div className={styles.toggleWrapper}>*/}
      {/*    <Tooltip*/}
      {/*      color="geekblue"*/}
      {/*      title={*/}
      {/*        isAlertEnabled*/}
      {/*          ? "Click to disable alerts"*/}
      {/*          : "Click to enable alerts"*/}
      {/*      }*/}
      {/*    >*/}
      {/*      <div className={styles.switchContainer}>*/}
      {/*        <FaPowerOff*/}
      {/*          className={styles.powerIcon}*/}
      {/*          color={isAlertEnabled ? "#44bd32" : "#ff4d4f"}*/}
      {/*        />*/}
      {/*        <Switch*/}
      {/*          checked={isAlertEnabled}*/}
      {/*          loading={activeAlertLoading}*/}
      {/*          onChange={(checked) => {*/}
      {/*            if (!checked) {*/}
      {/*              confirmDisableAlert();*/}
      {/*            } else {*/}
      {/*              activateAlertSystem({});*/}
      {/*            }*/}
      {/*          }}*/}
      {/*          checkedChildren="Enabled"*/}
      {/*          unCheckedChildren="Disabled"*/}
      {/*        />*/}
      {/*      </div>*/}
      {/*    </Tooltip>*/}
      {/*  </div>*/}
      {/*)}*/}
      {isAlertActive ? (
        <>
          <RiskAppetiteBox />
          <AlertFrequencyBox />
          <AlertTimeBox />
          <TelegramNotificationBox />
        </>
      ) : (
        <div className={styles.inactiveServiceBox}>
          <div className={styles.title}>
            <div className={styles.iconWrapper}>
              <FaBell className={styles.bellIcon} />
            </div>
            <h3>Get full access to smart alerts.</h3>
          </div>
          <p>
            {" "}
            Activate the Alert System to take control of your timing and risk
            preferences.
          </p>
          <span
            className={styles.activateButton}
            onClick={() => setShowServiceActivation(true)}
          >
            Activate Now
          </span>

          {showServiceActivation && (
            <ServiceActivationModal
              show={showServiceActivation}
              setShow={setShowServiceActivation}
              service="alert"
            />
          )}
        </div>
      )}
    </div>
  );
};
export default AlertSystem2;
